if (!customElements.get("m-custom-content-slider")) {
  class MCustomContentSlider extends HTMLElement {
    constructor() {
      super();
      this.handleResponsiveChange = this.handleResponsiveChange.bind(this);
      this.syncPagination = this.syncPagination.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.container = this.querySelector("[data-slider-container]");
      this.wrapper = this.querySelector("[data-slider-wrapper]");
      this.items = this.querySelectorAll("[data-slider-item]");
      this.pagination = this.querySelector(".swiper-pagination");
      this.controls = this.querySelector(".m-slider-controls");
      this.gap = parseInt(this.dataset.gap, 10) || 0;
      this.mobileItems = parseFloat(this.dataset.mobileItems) || 1;
      this.dotLabel = this.dataset.dotLabel || "Go to slide [index]";
      document.addEventListener("matchMobile", this.handleResponsiveChange);
      document.addEventListener("unmatchMobile", this.handleResponsiveChange);
      this.handleResponsiveChange();
    }

    disconnectedCallback() {
      document.removeEventListener("matchMobile", this.handleResponsiveChange);
      document.removeEventListener("unmatchMobile", this.handleResponsiveChange);
      this.destroySlider();
      this.initialized = false;
    }

    handleResponsiveChange() {
      if (MinimogTheme.config.mqlMobile) {
        this.initSlider();
      } else {
        this.destroySlider();
      }
    }

    initSlider() {
      if (this.slider || !this.container || this.items.length < 2) {
        this.syncPagination();
        return;
      }

      this.container.classList.add("swiper-container");
      this.wrapper.classList.add("swiper-wrapper");
      this.items.forEach((item) => item.classList.add("swiper-slide"));
      this.slider = new MinimogLibs.Swiper(this.container, {
        slidesPerView: this.mobileItems,
        slidesPerGroup: 1,
        spaceBetween: this.gap,
        loop: false,
        watchOverflow: true,
        threshold: 2,
        pagination: this.pagination
          ? {
              el: this.pagination,
              clickable: true,
              renderBullet: (index, className) => {
                const label = this.escapeHtml(this.dotLabel.replace("[index]", index + 1));
                return `<button type="button" class="${className}" aria-label="${label}"></button>`;
              },
            }
          : false,
        on: {
          init: this.syncPagination,
          slideChange: this.syncPagination,
          paginationRender: this.syncPagination,
          resize: this.syncPagination,
          update: this.syncPagination,
          lock: this.syncPagination,
          unlock: this.syncPagination,
        },
      });
      this.syncPagination();
    }

    destroySlider() {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
      if (this.container) this.container.classList.remove("swiper-container");
      if (this.wrapper) this.wrapper.classList.remove("swiper-wrapper");
      if (this.items) this.items.forEach((item) => item.classList.remove("swiper-slide"));
      if (this.controls) this.controls.classList.add("m:hidden");
    }

    syncPagination() {
      const hasPages = this.slider && !this.slider.isLocked && this.slider.snapGrid.length > 1;
      if (this.controls) this.controls.classList.toggle("m:hidden", !hasPages);
      if (!this.pagination) return;

      this.pagination.querySelectorAll("button").forEach((button) => {
        if (button.classList.contains("swiper-pagination-bullet-active")) {
          button.setAttribute("aria-current", "true");
        } else {
          button.removeAttribute("aria-current");
        }
      });
    }

    escapeHtml(value) {
      return value
        .replaceAll("&", "&amp;")
        .replaceAll('"', "&quot;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;");
    }
  }

  customElements.define("m-custom-content-slider", MCustomContentSlider);
}
